export default "__VITE_ASSET__0jaZEqO$__"